export default {
  messages: {
    postAssessmentPromotion: {
      title: {
        bizmates: ''
      },
      ctaButton: {
        bizmates: '訂閱付費方案'
      },
      royalBenefitsNote: {
        bizmates: '＊您可能符合會員專屬優惠資格。請點擊「訂閱付費方案」按鈕，並於下一頁確認詳細資訊。'
      },
      footerNote: {
        title: {
          bizmates: '對於那些覺得免費試聽課很難的人來說'
        },
        content: {
          bizmates: '在 Bizmates，我們提供根據您的程度量身定制的學習資料和老師。事實上，大約一半的 Bizmates 學員都是英語初學者。每個人都是從覺得「困難」的起點開始的。'
        }
      }
    }
  }
};
